"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.72 3.576C6.845 3.213 8.36 3 10 3s3.153.213 4.28.576c.56.18 1.064.41 1.442.699.368.28.728.705.728 1.278v8.894c0 .573-.36.998-.728 1.278-.378.289-.882.518-1.442.699-1.127.363-2.64.576-4.28.576s-3.154-.213-4.28-.576c-.56-.18-1.064-.41-1.443-.699-.367-.28-.727-.705-.727-1.278V5.553c0-.573.36-.998.727-1.278.379-.289.883-.518 1.442-.699M4.95 5.57c.009-.02.046-.082.176-.18.203-.156.542-.325 1.023-.48.954-.308 2.315-.509 3.85-.509s2.898.201 3.852.509c.48.155.82.324 1.023.48.13.098.167.16.176.18v8.862a.567.567 0 0 1-.176.18c-.204.155-.542.325-1.023.48-.954.308-2.316.509-3.851.509s-2.897-.201-3.851-.509c-.481-.155-.82-.324-1.023-.48-.13-.098-.167-.16-.176-.18z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.95 5.536a.7.7 0 0 0-1.4.017c0 .573.36.998.727 1.278.379.289.883.518 1.442.699 1.127.363 2.64.576 4.28.576s3.154-.213 4.281-.576c.56-.18 1.064-.41 1.442-.699.368-.28.728-.705.728-1.278a.7.7 0 0 0-1.4-.017c-.009.02-.045.082-.176.181-.204.155-.542.325-1.023.48-.954.307-2.316.509-3.851.509s-2.897-.202-3.851-.509c-.481-.155-.82-.325-1.023-.48-.131-.1-.168-.161-.176-.18m0 5.929a.7.7 0 0 0-1.4.016c0 .573.36.998.727 1.279.379.288.883.518 1.442.698 1.127.363 2.64.576 4.28.576s3.154-.213 4.281-.576c.56-.18 1.064-.41 1.442-.698.368-.28.728-.706.728-1.279a.7.7 0 0 0-1.4-.016c-.009.02-.045.081-.176.18-.204.156-.542.325-1.023.48-.954.308-2.316.51-3.851.51s-2.897-.202-3.851-.51c-.481-.155-.82-.324-1.023-.48-.131-.099-.168-.16-.176-.18",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.95 8.501a.7.7 0 0 0-1.4.017c0 .572.36.998.727 1.278.379.288.883.518 1.442.698 1.127.363 2.64.577 4.28.577s3.154-.214 4.281-.577c.56-.18 1.064-.41 1.442-.698.368-.28.728-.706.728-1.278a.7.7 0 0 0-1.4-.017c-.009.02-.045.081-.176.181-.204.155-.542.325-1.023.48-.954.307-2.316.509-3.851.509s-2.897-.202-3.851-.51c-.481-.154-.82-.324-1.023-.479-.131-.1-.168-.162-.176-.18",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=DatatableIcon20.js.map